import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import i18next from "i18next";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import PlaceholderWrapper from "../../Common/PlaceholderWrapper";
import PopupEditor from "../../Common/PopupEditor";
import {renderHTML} from "@mnjsplatform/data/lib/utils/htmlUtils";

class SubPositionResponsibilities extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            viewName: 'Employees',
            editFormVisible: false
        }
    }

    componentDidMount() {
        this.initialize();
    }

    initialize = async () => {
        try {
            this.key = {SubTabNum: this.props.homeState.appParams.tabNum, UseFilters: 1};
            await this.props.dispatch(this.props.dataItem_Paramset.execute(this.key, {withParams: true}));
            await this.props.dispatch(this.props.dataItem_Employees.execute(this.key));
            await this.props.dispatch(this.props.dataItem_Positions.execute(this.key));
        } catch (e) {
            console.error(e);
        }
    }
    changeView = async (viewName, e) => {
        if (e) e.preventDefault();
        this.setState({viewName: viewName});
    }
    renderParams = (h) => {
        return (<div className="row mx-auto">
            <div className="col-md-12">
                {h.fs.map((fi) => {
                    const fn = fi.Name;
                    return (<React.Fragment key={fn}>
                        <div className="row">
                            <div className="col-md-3 field-title">
                                {h.lbl(fn)}
                            </div>
                            <div className="col-md-9">
                                {h.ed(fn)}
                            </div>
                        </div>
                        <hr/>
                    </React.Fragment>)
                })}
            </div>
        </div>)
    }
    refresh = async () => {
        await this.props.dispatch(this.props.dataItem_Employees.refresh(this.key));
        await this.props.dispatch(this.props.dataItem_Positions.refresh(this.key));
    }
    cellClick = async(row, fieldInfo, e) => {
        await this.props.dispatch(this.props.dataItem_Edit.execute({OrgStructIntId: row.OrgStructIntId}));
        this.setState({editFormVisible: true});
    }
    selectAddress = async (e, rowParams) => {
        if (e)
            e.preventDefault();
        await this.props.dispatch(rowParams.dataItem.setField(rowParams.rowIndex, 'IsSet', (rowParams.row.IsSet === 1 ? 0 : 1)));
        await this.props.dispatch(rowParams.dataItem.save(rowParams.rowIndex));
    }
    renderSubgridRowEx = (rowParams) => {
        return (
            <div style={{cursor: "pointer"}} key={rowParams.rowIndex}
                 onClick={(e) => this.selectAddress(e, rowParams)}>
                <input type="checkbox" className="checkbox" checked={rowParams.row.IsSet === 1}
                       style={{cursor: "pointer"}} onChange={() => {
                }}/>&nbsp;
                {rowParams.row.AddressName}
            </div>
        )
    }
    save = async (e) => {
        if (e) e.preventDefault();
        await this.props.dispatch(this.props.dataItem_Edit.save(0));
        if (!this.props.dataItem_Edit.isError) {
            this.closeEditForm(true);
        }
    }
    cancel = async(e) => {
        if (e) e.preventDefault();
        await this.props.dispatch(this.props.dataItem_Edit.cancelEdit());
        this.closeEditForm(false);
    }
    closeEditForm = (refresh = false) => {
        this.setState({editFormVisible: false}, async () => {
            if (refresh) {
                await this.refresh();
            }
        })
    }
    renderEditForm = (h) => {
        return (<div className="row">
            <div className="col-md-12">
                {h.fs.map((fi) => {
                    const fn = fi.Name;
                    return (<React.Fragment key={fn}>
                        <div className="row">
                            <div className="col-md-12">
                                {fi.Name === "SRDutyText"
                                    ? <PlaceholderWrapper collapsed={false} showSplitterLine={false} title={h.lbl(fn)}>
                                        {renderHTML(h.row[fi.Name])}
                                    </PlaceholderWrapper>
                                    : <>
                                        <div className="card-title">{h.lbl(fn)}</div>
                                        {h.ed(fn)}</>
                                }
                            </div>
                        </div>
                        <hr/>
                    </React.Fragment>)
                })}

            </div>
        </div>)
    }

    render() {
        const style = Object.assign({
            backgroundColor: "#fff",
            cursor: "pointer",
            ':active': {color: "#495057", borderColor: "#dee2e6 #dee2e6 #fff"}
        });
        return (<>
            <PlaceholderWrapper placeholderId="10" title={i18next.t("SubResponsibilities_1")} canCollapse={false}>
                <PlaceholderWrapper placeholderId="20" title={i18next.t('Filters')} canCollapse={true}
                                    showSplitterLine={false}>
                    <ComplexParam dataItem={this.props.dataItem_Params}
                                  parentDataItem={this.props.dataItem_Paramset}
                                  renderParams={this.renderParams}
                                  showApplyButton={false} autoApplyParams={true}
                                  afterApplyParams={this.refresh}
                                  autoFocusField="AdmStructName"
                                  showSearchBar={false}
                                  renderSubgridRowEx={this.renderSubgridRowEx}
                                  maxSubgridWidthBody=""
                                  showSubgridHeader={false}
                                  rootPath="/"/>
                </PlaceholderWrapper>
                <ul className="nav nav-tabs" role="tablist" id="nav-tab">
                    <li className="nav-item" key="Employees">
                        <a id="Employees-tab" data-toggle="tab" href="#EmployeesBlock" className="nav-link active"
                           style={style} role="tab" aria-current="page"
                           onClick={(e) => this.changeView('Employees', e)}
                           aria-controls="EmployeesBlock" aria-selected="true">{i18next.t("Employees")}
                        </a>
                    </li>
                    <li className="nav-item" key="Positions">
                        <a id="Positions-tab" data-toggle="tab" href="#PositionsBlock" className="nav-link"
                           style={style} role="tab"
                           onClick={(e) => this.changeView('Positions', e)}
                           aria-controls="PositionsBlock" aria-selected="false">{i18next.t("Positions")}
                        </a>
                    </li>
                </ul>
                <div className="tab-content">
                    <div id="EmployeesBlock" className="tab-pane show active inwhite card" role="tabpanel"
                         aria-labelledby="Employees-tab">
                        <GridView dataItem={this.props.dataItem_Employees}
                                  fixHeader={true} readOnly={true}
                                  onCellClick={this.cellClick}
                                  pageSize={10} allowPagination={true} activePageSize={5} rowCursor="pointer"/>
                    </div>
                    <div id="PositionsBlock" className="tab-pane inwhite card" role="tabpanel"
                         aria-labelledby="Positions-tab">
                        <GridView dataItem={this.props.dataItem_Positions}
                                  fixHeader={true} readOnly={true}
                                  onCellClick={this.cellClick}
                                  pageSize={10} allowPagination={true} activePageSize={5} rowCursor="pointer"/>
                    </div>
                </div>
            </PlaceholderWrapper>
            <PopupEditor
                visible={this.state.editFormVisible}
                dataItem={this.props.dataItem_Edit}
                readOnly={false}
                rowIndex={0}
                onSave={this.save}
                onCancel={this.cancel}
                usePortal={false}
                onParamRender={this.renderEditForm}
                /*maxWidthBody="400px"*/
            />
        </>);
    }
}
SubPositionResponsibilities.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataItem_Employees: PropTypes.object,
    dataItem_Positions: PropTypes.object,
    dataItem_Paramset: PropTypes.object,
    dataItem_Params: PropTypes.object,
    homeState: PropTypes.object,
    dataItem_Edit: PropTypes.object
}
SubPositionResponsibilities.defaultProps = {};
function mapStateToProps(state, ownProps) {
    return {
        homeState: state.appState,
        dataItem_Employees: state.subPositionResponsibilitiesState.AdmStruct_ListSubForPO,
        dataItem_Positions: state.subPositionResponsibilitiesState.AdmStructBoss_GetAllSRSubs,
        dataItem_Paramset: state.subPositionResponsibilitiesState.Duties_FiltersForPO,
        dataItem_Params: state.subPositionResponsibilitiesState.Duties_FiltersForPO_Params,
        dataItem_Edit: state.subPositionResponsibilitiesState.Duties_DisplayForUser
    }
}
export default connect(mapStateToProps)(SubPositionResponsibilities)